import { AppError } from "../../../app-store-error.types";
import { CurrenciesState, initialCurrenciesState } from "./currencies/currencies.state";
import { InterestRatesState, initialInterestRatesState } from "./interest-rates/interest-rates.state";
import { PaymentTermsState, initialPaymentTermsState } from "./payment-terms/payment-terms.state";
import { DeliveryTermsState, initialDeliveryTermsState } from "./delivery-terms/delivery-terms.state";
import { SalesCreditRolesState, initialSalesCreditRolesState } from "./sales-credit-roles/sales-credit-roles.state";
import { CompaniesState, initialCompaniesState } from "./companies/companies.state";
import { FinancingCompaniesState, initialFinancingCompaniesState } from "./financing-companies/financing-companies.state";
import { ExternalUsersState, initialExternalUsersState } from "./users/external-users/external-users.state";
import { InternalUsersState, initialInternalUsersState } from "./users/internal-users/internal-users.state";
import { CountriesState, initialCountriesState } from "./countries/countries.state";
import { QuoteSearchState, initialQuoteSearchState } from "./quote-search/quote-search.state";

// **************************************************************************
// SUPER USER STATE
// **************************************************************************
export interface SuperUserState {
    // Nested domain states (each feature has its own loading)
    currencies: CurrenciesState;
    interestRates: InterestRatesState;
    paymentTerms: PaymentTermsState;
    deliveryTerms: DeliveryTermsState;
    salesCreditRoles: SalesCreditRolesState;
    companies: CompaniesState;
    financingCompanies: FinancingCompaniesState;
    externalUsers: ExternalUsersState;
    internalUsers: InternalUsersState;
    countries: CountriesState;
    quoteSearch: QuoteSearchState;
    // Cross-cutting error state
    error: AppError | null;
}

export const initialSuperUserState: SuperUserState = {
    // Nested domain states
    currencies: initialCurrenciesState,
    interestRates: initialInterestRatesState,
    paymentTerms: initialPaymentTermsState,
    deliveryTerms: initialDeliveryTermsState,
    salesCreditRoles: initialSalesCreditRolesState,
    companies: initialCompaniesState,
    financingCompanies: initialFinancingCompaniesState,
    externalUsers: initialExternalUsersState,
    internalUsers: initialInternalUsersState,
    countries: initialCountriesState,
    quoteSearch: initialQuoteSearchState,
    // Cross-cutting
    error: null,
};
